import React from "react";
import ContactForm from "../Contact_us/contact/contact"; // Adjust the path based on your structure

const ContactUsPage = () => {
  return (
    <div>
      <ContactForm />
    </div>
  );
};

export default ContactUsPage;
